import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { DefaultErpTextType } from '../Enums/DefaultErpTextType.enum';
import { EMode } from '../Enums/EMode.enum';
import { SdObjType } from '../Enums/SdObjType.enum';

export class DefaultErpText<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: sdObjMemberCode */
  sdObjMemberCode?: number;
  /** Alias: sdObjType */
  sdObjType?: SdObjType;
  /** Alias: textType */
  textType?: DefaultErpTextType;
  /** Alias: text */
  text?: string;

  __typename?: string;
}

const fields: FieldDefinitions<DefaultErpText> = {
  id: {
    alias: 'code',
  },
  sdObjMemberCode: {
    alias: 'sdObjMemberCode',
  },
  sdObjType: {
    alias: 'sdObjType',
  },
  textType: {
    alias: 'textType',
  },
  text: {
    alias: 'text',
  },
  __typename: {
    alias: '__typename',
  },
};

export const defaultErpTextEntityDefinition: EntitiyDefinition<DefaultErpText> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'DefaultErpText',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
